import { MediaMatrixLayout } from "@/types/organization-settings/MediaMatrixLayout";

export const MediaMatrixSystemDefaults = {
	LAYOUT_INDEX: 3,
	LAYOUTS: [[1, 1], [2, 2], [2, 3], [3, 3], [4, 3], [4, 4]],
};

export const SystemDefaultMediaMatrixLayout: MediaMatrixLayout =  {
	layoutIndex: MediaMatrixSystemDefaults.LAYOUT_INDEX,
	layout: null,
	groupTitle:null,
	groupId: null,
	isSystemDefault: true,
};

export const MatrixLayoutIndices = {
	COL_INDEX: 0,
	ROW_INDEX: 1,
};